module.exports = __webpack_public_path__ + "static/media/figure-4b.bbc1cbce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/faq/change-batteries/figure-4b.jpg
// module id = 1210
// module chunks = 0